import { render, staticRenderFns } from "./BlockSlideshowContent.vue?vue&type=template&id=71a9db26&scoped=true&"
import script from "./BlockSlideshowContent.vue?vue&type=script&lang=js&"
export * from "./BlockSlideshowContent.vue?vue&type=script&lang=js&"
import style0 from "./BlockSlideshowContent.vue?vue&type=style&index=0&id=71a9db26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a9db26",
  null
  
)

export default component.exports